import ConfigurationSection from "./ConfigurationSection"

export default function ConfigurationModal({ clientId, onClose }) {
  return (
    <ConfigurationSection clientId={clientId} onBack={onClose} />
  )
} 